import { render, staticRenderFns } from "./ProductPriceHistory.vue?vue&type=template&id=b3e7697e"
import script from "./ProductPriceHistory.vue?vue&type=script&lang=js"
export * from "./ProductPriceHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports